module.exports = __webpack_public_path__ + "img/image11.d2e7a97f.png";